// Third Party Libraries
import * as $ from 'jquery';

export default {
	name: 'ModalCustomRecipients',
	data() {
		return {
			modalContent: null
		}
	},
	beforeDestroy() {
		this.hideModal();
	},
	methods: {
		show(content) {
			this.modalContent = content;
			$(this.$refs.modalCustomRecipients).modal('show');
		},
		hideModal() {
			$(this.$refs.modalCustomRecipients).modal('hide');
		}
	}
}